import ControllerBase from '../../../../global/js/ControllerBase';
export default class ControllerDatePicker extends ControllerBase {

	private dateInput;
	private maxDate;
	private currendDate;

	constructor(element: HTMLElement) {
		super(element);
		this.maxDateHandler();
	}

	private maxDateHandler() {
		this.dateInput = this.$element?.querySelector('input[type="date"]') as HTMLInputElement;
		if (this.dateInput) this.maxDate = this.dateInput?.getAttribute('data-max') as HTMLElement;
		const date = new Date();
		this.currendDate = date.toISOString().substr(0, 10);
		this.dateInput.setAttribute('max', this.maxDate ? this.maxDate : this.currendDate);
	}
}
